import React from "react";
import { Button } from "react-bootstrap";
import HeaderLayout from "./HeaderLayout";
import CardsLayout from "./cardsLayout";
import { Link } from "react-router-dom";
import { getVendorInformationBydDC, updateVendorInfByDc } from "../../../actions";
import Spinner from "../../common/Spinner";
import Sanckbar from "../../common/Sanckbar";
import StatusModal from "../../common/StatusModal";


class LookupVendorInformationByDcDiVendors extends React.Component {
  state = {
    notificationMsg: "",
    isSaveEnabled: false
  };
  constructor() {
    super();
    this.cardsData = [];
    this.allData = {};
    this.oldInfo = [];
    this.newInfo = {};
  }
  componentDidMount() {
    document.addEventListener("keydown", this.pressEnter);
  }
  setErrorMessage = msg => {
    this.setNotification(msg, "red", "cancel");
  };
  setWarningMessage = msg => {
    this.setNotification(msg, "orange", "warning", 3000);
  };
  setSuccessMessage = msg => {
    this.setNotification(msg, "#47fb47", "check", 3000);
  };
  setTransitioMessage = msg => {
    this.setNotification(msg, null, null);
  };
  setNotification = (text, color, icon, timeout) => {
    clearTimeout(this.snackbarTimer);

    if (text) {
      this.setState({ notificationMsg: { text, color, icon } });
      this.setState({ isNotificationOpened: true });
    } else {
      this.setState({ isNotificationOpened: false });
    }
    if (timeout) {
      this.snackbarTimer = setTimeout(() => {
        this.setState({ isNotificationOpened: false });
      }, timeout);
    }
  };
  lookup = msg => {
    this.setTransitioMessage(<Spinner msg="Loading..." />);
    if (this.state.lookup && this.state.lookup.wse) {
      var vendor = this.state.lookup.item;
      getVendorInformationBydDC(vendor, this.state.lookup.wse).then(res => {
        msg ? this.setSuccessMessage(msg) : this.setTransitioMessage("");
        var data = [];
        if (res.data.success) {
          data = res.data.data;
        } else {
          data = false;
          this.setErrorMessage("Nothing found.");
        }
        if (res.data.success) {
          this.setState({ data });
         // data.vdiContainerLoad.replace(/\s/g, "");
          this.setState({
            header: [
              { 
                label: "Vendor", 
                name: "vendor", 
                value: data === false ? " " : data.vwhVendor },
              {
                label: "Vendor Name",
                name: "vendorName",
                value: data === false ? " " : data.vendorName
              },
              { label: "PM", name: "tagPM", value: "00" },
              { label: "Warehouses", name: "wse" }
            ],
            cards: [
              {
                Card: [
                  {
                    label: "PO Payment Terms",
                    name: "vwhPoPmntTerms",
                    value: data === false ? " " : data.vwhPoPmntTerms
                  },
                  {
                    label: "Container Flag",
                    name: "vdiContainerLoad",
                    value: data === false ? " " : data.vdiContainerLoad.replace(/\s/g, "")
                  },
                  {
                    label: "Incoterms",
                    name: "vwhIncoTerms",
                    value: data === false ? " " : data.vwhIncoTerms
                  },
                  {
                    label: "Factory Build Days",
                    name: "vwhFbuildDays",
                    value: data === false ? " " : data.vwhFbuildDays
                  },
                  {
                    label: "Production Days",
                    name: "vwhProdDays",
                    value: data === false ? " " : data.vwhProdDays
                  },
                  {
                    label: "Stacking",
                    name: "vdiStacking",
                    value: data === false ? " " : data.vdiStacking
                  },
                  {
                    label: "Port of Loading",
                    name: "vdiLoadPort",
                    value: data === false ? " " : data.vdiLoadPort
                  },
                  {
                    label: "Factory Transit Days",
                    name: "vwhFtransitDays",
                    value: data === false ? " " : data.vwhFtransitDays
                  },
                  {
                    label: "Consolidation Days",
                    name: "vwhConsolidDays",
                    value: data === false ? " " : data.vwhConsolidDays
                  },
                  {
                    label: "Export Custom Days",
                    name: "vwhEcustomDays",
                    value: data === false ? " " : data.vwhEcustomDays
                  },
                  {
                    label: "Country Code",
                    name: "countryCode",
                    value: data === false ? " " : data.countryCode
                  },
                  {
                    label: "Transport Mode",
                    name: "vdiTransportMode",
                    value: data === false ? " " : data.vdiTransportMode
                  },
                  {
                    label: "Source Agent",
                    name: "vdiSourceAgent",
                    value: data === false ? " " : data.vdiSourceAgent
                  },
                  {
                    label: "Ship Load Days",
                    name: "vwhShipLoadDays",
                    value: data === false ? " " : data.vwhShipLoadDays
                  },
                  {
                    label: "Ocean Transit Days",
                    name: "vwhOtransitDays",
                    value: data === false ? " " : data.vwhOtransitDays
                  },
                  {
                    label: "EDI Destination Code",
                    name: "vwhEdiDest",
                    value: data === false ? " " : data.vwhEdiDest
                  },
                  {
                    label: "EDI DI Vendor",
                    name: "vwhEdiVendor",
                    value: data === false ? " " : data.vwhEdiVendor
                  },
                  {
                    label: "Ship Unload Days",
                    name: "vwhShipUnldDays",
                    value: data === false ? " " : data.vwhShipUnldDays
                  },
                  {
                    label: "Import Custom Days",
                    name: "vwhIcustomDays",
                    value: data === false ? " " : data.vwhIcustomDays
                  },
                  {
                    label: "Dom. Transit Days",
                    name: "vwhDctransitDays",
                    value: data === false ? " " : data.vwhDctransitDays
                  },
                  {
                    label: "Container Size",
                    name: "vwhContainerSize",
                    value: data === false ? " " : data.vwhContainerSize
                  },
                  {
                    label: "Standard Lead Time",
                    name: "vwhStdLeadTime",
                    value: data === false ? " " : data.vwhStdLeadTime
                  },
                  {
                    label: "Variance Days",
                    name: "vwhVarianceDays",
                    value: data === false ? " " : data.vwhVarianceDays
                  },
                  {
                    label: "PSI Compliance Frequency",
                    name: "vwhPsiCompliance",
                    value: data === false ? " " : data.vwhPsiCompliance
                  },
                  {
                    label: "PSI Compliance Every",
                    name: "vwhPsiDetailDays",
                    value: data === false ? " " : data.vwhPsiDetailDays
                  },
                  {
                    label: "Days",
                    name: "unitShippedTag",
                    value: data === false ? " " : data.unitShippedTag
                  },
                  {
                    label: "PSI Last Compliance",
                    name: "vwhPsiLastDate",
                    value: data === false ? " " : data.vwhPsiLastDate
                  }
                ]
              }
            ]
          });
        } else {
          this.setErrorMessage(res.data.messages[0].text);
          setTimeout(() => {
            this.setErrorMessage();
          }, 2000);
        }
      }).catch(err => {
        const code = String(err).split('code')[1];
        if(code == 401) {
          this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
        } else {
            this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
            setTimeout(() => {
              this.setErrorMessage();
            }, 3000);
        }
      });
    } else {
      this.setErrorMessage("Please type vendor and select a warehouse");
            setTimeout(() => {
              this.setErrorMessage();
            }, 2000);
    }
  };
  getHeaderInfo = value => {
    this.setState({
      lookup: {
        item: value.header.vendor,
        wse: value.header.wse
      }
    });

    this.handleInformation(value);
  };
  getCardsInfo = value => {
    this.handleInformation(value);
  };
  handleInformation = value => {
    Object.keys(value[Object.keys(value)]).map(
      val => (this.allData[val] = value[Object.keys(value)][val])
    );
    if (this.state.data) {
      for (let i = 0; i < Object.keys(this.state.data).length; i++) {
        this.newInfo[Object.keys(this.state.data)[i]] = this.allData[
          Object.keys(this.state.data)[i]
        ]
          ? this.allData[Object.keys(this.state.data)[i]]
          : this.state.data[Object.keys(this.state.data)[i]];
      }
      this.checkHotChanges();
    }
  };
  checkHotChanges = () => {
    this.setState({
      isSaveEnabled:
        JSON.stringify(this.state.data).replace(/"/g, "") !==
        JSON.stringify(this.newInfo).replace(/"/g, "")
    });
  };

  save = () => {
    var uId = sessionStorage.getItem("uId");
    var obj = {
      audit: {
        userId: uId
      },
      data: {
        vendor: this.newInfo.vdiVendor,
        whse: this.state.lookup.wse[0],
        containerSize: this.newInfo.vwhContainerSize.toUpperCase(),
        containerFlag: this.newInfo.vdiContainerLoad.toUpperCase()
      } 
    };

    this.setTransitioMessage(<Spinner msg="Saving..." />);

    updateVendorInfByDc(obj).then(res => {
      if (res.data.success) {
        this.setState({ data: "" });
        this.newInfo = {};
        this.lookup("Item was successfully updated");
        this.setSuccessMessage("Item was successfully updated");
        this.setState({ isSaveEnabled: false });
        this.lookup();
      } else {
        this.setErrorMessage(res.data.messages[0].text);
        setTimeout(() => {
          this.setErrorMessage();
        }, 2000);
      }
    }).catch(err => {
      const code = String(err).split('code')[1];
      if(code == 401) {
        this.setErrorMessage(`Error code ${code}, token expired, please login again.`);
        setTimeout(() => {
          this.setErrorMessage();
        }, 3000);
      } else {
          this.setErrorMessage(`Error code ${code}, cannot complete the action now, please try again later.`);
          setTimeout(() => {
            this.setErrorMessage();
          }, 3000);
      }
    });
  };

  pressEnter = e => {
    if (e.key === "Enter") {
      this.lookup();
    }
  };

  numberToZeroPadded = (num, z) => {
    var no = parseInt(num, 10);
    num = no.toString();
    var zeroNo = z - num.length;
    var zeros = "";
    for (let i = 0; i < zeroNo; i++) {
      zeros = "0" + zeros;
    }
    return zeros + no;
  };

  componentWillUnmount() {
    document.removeEventListener("keydown", this.pressEnter);
  }

  handleOpenModal = () => {
    this.state.modalOpen
      ? this.setState({ modalOpen: false })
      : this.setState({ modalOpen: true });
  };
  closeModal = e => {
    this.setState({ modalOpen: false });
  };
  closeEP = x => {
    if (x) {
      x.target.textContent === "Save"
        ? this.save()
        : this.setSuccessMessage("Changes discarded");

      setTimeout(() => {
        this.closeEP();
      }, 1500);
    } else {
      this.props.history.push("/");
    }
  };


  checkHotChangesAndClose = () => {
    if (this.state.isSaveEnabled) {
      this.handleOpenModal();
    } else {
      this.closeEP();
    }
  };

  render() {
    return (
      <div className="container-fluid" id="example">
        <h3 className="page-title" style={{ textAlign: "center" }}>
          Look Up Vendor Information by DC for DI Vendors
        </h3>
        <HeaderLayout
          setHeaderInfo={this.getHeaderInfo}
          setErrorMessage={this.setErrorMessage}
          setSuccessMessage={this.setSuccessMessage}
          lookup={this.lookup}
          headerData={this.state.header}
        />
        <CardsLayout
          cardsData={this.state.cards}
          setCardsInfo={this.getCardsInfo}
        />

        <div className="button-bar">
          <div className="paginator" style={{ display: "flex" }} />
          <div className="buttons">
              <Button bsStyle="warning" className="btn-sm" disabled={false}>
                Close
              </Button>
              <Button
              bsStyle="warning"
              className="btn-sm"
              disabled={!this.state.isSaveEnabled}
              onClick={e => this.save()}
            >
              Save
            </Button>
          </div>
        </div>
        <Sanckbar
          mounted={this.state.isNotificationOpened}
          msg={{
            text: this.state.notificationMsg.text,
            color: this.state.notificationMsg.color,
            icon: this.state.notificationMsg.icon
          }}
          close={this.setNotification}
        />
        <StatusModal
          modal={this.state.modalOpen === true ? "opened" : "closed"}
          action={"choice"}
          handleOpenClose={e => this.closeModal(e)}
          buttonActions={{
            button2: this.closeEP,
            button1: this.closeEP
          }}
          msg={
            "There are unsaved changes. Please select one of the following actions."
          }
          active={true}
          buttonText2={"Save"}
          buttonText={"Discard"}
        />
      </div>
    );
  }
}
export default LookupVendorInformationByDcDiVendors;
